import {
  RECEIVED_PRIORITY_RENTALS
} from './actions'

export default function reducer (state = {
  priorityRentals: null
}, action) {
  switch (action.type) {
    case RECEIVED_PRIORITY_RENTALS:
      return {
        ...state,
        priorityRentals: action.priorityRentals
      }
    default:
      return state
  }
}
